import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function NewsletterForm({ dark, testId = "newsletter" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message);
      setEmail("");
    } catch {
      toast.error("Controlla l'email e riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3" data-testid={`${testId}-form`}>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="La tua email"
        className="ws-input flex-1"
        data-testid={`${testId}-email-input`}
      />
      <button type="submit" disabled={loading} className="btn-primary" data-testid={`${testId}-submit-button`}>
        {loading ? "..." : "Iscrivimi"}
      </button>
    </form>
  );
}
